import React from 'react';
import { useAtom } from 'jotai';
import { upmarketDataAtom } from '@fiverr-private/seller_pages_toolbox';
import { DesBanner, MultiBanner } from './banners';

export const UpmarketBanners = () => {
    const [upmarketData] = useAtom(upmarketDataAtom);
    const { segment: upmarketSegment } = upmarketData;

    const withDesBanner = upmarketSegment?.proBuType === 'MPFit';
    const withMultiVariantBanner = upmarketSegment?.proBuType === 'ProFit';

    if (withDesBanner) {
        return <DesBanner />;
    }

    if (withMultiVariantBanner) {
        return <MultiBanner />;
    }

    return null;
};
